"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultFilter = exports.InlineComboboxItem = exports.InlineComboboxInput = exports.InlineComboboxEmpty = exports.InlineComboboxContent = exports.InlineCombobox = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@ariakit/react");
var _cn = require("@udecode/cn");
var _plateCombobox = require("@udecode/plate-combobox");
var _plateCommon = require("@udecode/plate-common");
var _classVarianceAuthority = require("class-variance-authority");
var _useHtmlInputCursorState = require("../hooks/useHtmlInputCursorState");
var _useComboboxInput = require("../hooks/useComboboxInput");
var _jsxRuntime = require("react/jsx-runtime");
// For some reason Typescript complains that the imported modules do not exist - but they very much do...

var InlineComboboxContext = /*#__PURE__*/(0, _react.createContext)(null);
var defaultFilter = function defaultFilter(_ref, search) {
  var _ref$keywords = _ref.keywords,
    keywords = _ref$keywords === void 0 ? [] : _ref$keywords,
    value = _ref.value;
  return [value].concat(_toConsumableArray(keywords)).some(function (keyword) {
    return keyword && (0, _plateCombobox.filterWords)(keyword, search);
  });
};
exports.defaultFilter = defaultFilter;
var InlineCombobox = function InlineCombobox(_ref2) {
  var children = _ref2.children,
    element = _ref2.element,
    _ref2$filter = _ref2.filter,
    filter = _ref2$filter === void 0 ? defaultFilter : _ref2$filter,
    _ref2$hideWhenNoValue = _ref2.hideWhenNoValue,
    hideWhenNoValue = _ref2$hideWhenNoValue === void 0 ? false : _ref2$hideWhenNoValue,
    setValueProp = _ref2.setValue,
    _ref2$showTrigger = _ref2.showTrigger,
    showTrigger = _ref2$showTrigger === void 0 ? true : _ref2$showTrigger,
    trigger = _ref2.trigger,
    valueProp = _ref2.value;
  var editor = (0, _plateCommon.useEditorRef)();
  var inputRef = _react.default.useRef(null);
  var cursorState = (0, _useHtmlInputCursorState.useHTMLInputCursorState)(inputRef);
  var _ref7 = (0, _react.useState)(''),
    _ref8 = _slicedToArray(_ref7, 2),
    valueState = _ref8[0],
    setValueState = _ref8[1];
  var hasValueProp = valueProp !== undefined;
  var value = hasValueProp ? valueProp : valueState;
  var _setValue = (0, _react.useCallback)(function (newValue) {
    setValueProp === null || setValueProp === void 0 ? void 0 : setValueProp(newValue);
    if (!hasValueProp) {
      setValueState(newValue);
    }
  }, [setValueProp, hasValueProp]);

  /**
   * Track the point just before the input element so we know where to
   * insertText if the combobox closes due to a selection change.
   */
  var _ref9 = (0, _react.useState)(null),
    _ref10 = _slicedToArray(_ref9, 2),
    insertPoint = _ref10[0],
    setInsertPoint = _ref10[1];
  var _ref11 = (0, _useComboboxInput.useComboboxInput)({
      cancelInputOnBlur: false,
      // this needs to be false or we will get an error when attempting to remove the input field
      cursorState: cursorState,
      onCancelInput: function onCancelInput(cause) {
        if (cause !== 'backspace') {
          var _insertPoint$current;
          (0, _plateCommon.insertText)(editor, trigger + value, {
            at: (_insertPoint$current = insertPoint === null || insertPoint === void 0 ? void 0 : insertPoint.current) !== null && _insertPoint$current !== void 0 ? _insertPoint$current : undefined
          });
        }
        if (cause === 'arrowLeft' || cause === 'arrowRight') {
          (0, _plateCommon.moveSelection)(editor, {
            distance: 1,
            reverse: cause === 'arrowLeft'
          });
        }
      },
      ref: inputRef
    }),
    inputProps = _ref11.props,
    removeInput = _ref11.removeInput;
  (0, _react.useEffect)(function () {
    var path = (0, _plateCommon.findNodePath)(editor, element);
    if (!path) return;
    try {
      var point = (0, _plateCommon.getPointBefore)(editor, path);
      if (!point) return;
      var pointRef = (0, _plateCommon.createPointRef)(editor, point);
      setInsertPoint(pointRef);
      return function () {
        pointRef.unref();
      };
    } catch (error) {}
  }, [editor, element]);
  var _ref12 = (0, _react.useState)(false),
    _ref13 = _slicedToArray(_ref12, 2),
    hasEmpty = _ref13[0],
    setHasEmpty = _ref13[1];
  var contextValue = (0, _react.useMemo)(function () {
    return {
      filter: filter,
      inputProps: inputProps,
      inputRef: inputRef,
      removeInput: removeInput,
      setHasEmpty: setHasEmpty,
      showTrigger: showTrigger,
      trigger: trigger
    };
  }, [trigger, showTrigger, filter, inputRef, inputProps, removeInput, setHasEmpty]);
  var store = (0, _react2.useComboboxStore)({
    // open: ,
    setValue: function setValue(newValue) {
      return function () {
        return _setValue(newValue);
      };
    }
  });
  var items = store.useState('items');

  /**
   * If there is no active ID and the list of items changes, select the first
   * item.
   */
  (0, _react.useEffect)(function () {
    if (!store.getState().activeId) {
      store.setActiveId(store.first());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items, store]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    contentEditable: false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ComboboxProvider, {
      open: (items.length > 0 || hasEmpty) && (!hideWhenNoValue || value.length > 0),
      store: store,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(InlineComboboxContext.Provider, {
        value: contextValue,
        children: children
      })
    })
  });
};
exports.InlineCombobox = InlineCombobox;
var InlineComboboxInput = exports.InlineComboboxInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, propRef) {
  var className = _ref3.className,
    props = _objectWithoutProperties(_ref3, ["className"]);
  var _ref14 = (0, _react.useContext)(InlineComboboxContext),
    inputProps = _ref14.inputProps,
    contextRef = _ref14.inputRef,
    showTrigger = _ref14.showTrigger,
    trigger = _ref14.trigger;
  var store = (0, _react2.useComboboxContext)();
  var value = store.useState('value');
  var ref = (0, _plateCommon.useComposedRef)(propRef, contextRef);

  /**
   * To create an auto-resizing input, we render a visually hidden span
   * containing the input value and position the input element on top of it.
   * This works well for all cases except when input exceeds the width of the
   * container.
   */

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
    className: 'plate-editor-wrapper',
    children: [showTrigger && trigger, /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
      className: "relative min-h-[1lh]",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        "aria-hidden": "true",
        className: "invisible overflow-hidden text-nowrap",
        children: value || "\u200B"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Combobox, _objectSpread({
        autoSelect: true,
        className: (0, _cn.cn)('absolute left-0 top-0 size-full bg-transparent outline-none', className),
        ref: ref,
        value: value
      }, inputProps, props))]
    })]
  });
});
InlineComboboxInput.displayName = 'InlineComboboxInput';
var InlineComboboxContent = function InlineComboboxContent(_ref4) {
  var className = _ref4.className,
    props = _objectWithoutProperties(_ref4, ["className"]); // Portal prevents CSS from leaking into popover
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.Portal, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: 'plate-editor-wrapper',
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ComboboxPopover, _objectSpread({
        style: {
          zIndex: 100000
        },
        className: (0, _cn.cn)('z-[5000] max-h-[288px] w-[300px] overflow-y-auto rounded-md bg-popover shadow-md', className)
      }, props))
    })
  });
};
exports.InlineComboboxContent = InlineComboboxContent;
var comboboxItemVariants = (0, _classVarianceAuthority.cva)('relative flex h-9 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none', {
  defaultVariants: {
    interactive: true
  },
  variants: {
    interactive: {
      false: '',
      true: 'cursor-pointer transition-colors hover:bg-accent hover:text-accent-foreground data-[active-item=true]:bg-accent data-[active-item=true]:text-accent-foreground'
    }
  }
});
var InlineComboboxItem = function InlineComboboxItem(_ref5) {
  var className = _ref5.className,
    keywords = _ref5.keywords,
    _onClick = _ref5.onClick,
    props = _objectWithoutProperties(_ref5, ["className", "keywords", "onClick"]);
  var value = props.value;
  var _ref15 = (0, _react.useContext)(InlineComboboxContext),
    filter = _ref15.filter,
    removeInput = _ref15.removeInput;
  var store = (0, _react2.useComboboxContext)();

  // Optimization: Do not subscribe to value if filter is false
  var search = filter && store.useState('value');
  var visible = (0, _react.useMemo)(function () {
    return !filter || filter({
      keywords: keywords,
      value: value
    }, search);
  }, [filter, value, keywords, search]);
  if (!visible) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ComboboxItem, _objectSpread({
    className: (0, _cn.cn)(comboboxItemVariants(), className),
    onClick: function onClick(event) {
      removeInput(true);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
    }
  }, props));
};
exports.InlineComboboxItem = InlineComboboxItem;
var InlineComboboxEmpty = function InlineComboboxEmpty(_ref6) {
  var children = _ref6.children,
    className = _ref6.className;
  var _ref16 = (0, _react.useContext)(InlineComboboxContext),
    setHasEmpty = _ref16.setHasEmpty;
  var store = (0, _react2.useComboboxContext)();
  var items = store.useState('items');
  (0, _react.useEffect)(function () {
    setHasEmpty(true);
    return function () {
      setHasEmpty(false);
    };
  }, [setHasEmpty]);
  if (items.length > 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _cn.cn)(comboboxItemVariants({
      interactive: false
    }), className),
    children: children
  });
};
exports.InlineComboboxEmpty = InlineComboboxEmpty;